module.exports = __webpack_public_path__ + "img/filter01.dc008bc4.png";